import constants from "../common/constants";

export const ARRAY_GROUP_SESSIONS = [
  constants.SS_KEY_GROUP_LOGIN_DETAILS,
  constants.SS_KEY_GROUP_CLIENT_DETAILS,
  constants.SS_KEY_GROUP_POLICY_DETAILS,
  constants.SS_KEY_GROUP_CLIENT_LIST,
  constants.SS_KEY_GROUP_CUSTOMER_SESSION,
  constants.SS_KEY_GROUP_ACCESS_TOKEN,
  constants.SS_KEY_GROUP_ACCESS_TOKEN_EXPIRESBY,
  constants.SS_KEY_GROUP_REFRESH_TOKEN,
  constants.SS_KEY_GROUP_REFRESH_TOKEN_EXPIRESBY,
  constants.SS_KEY_GROUP_DATA_MOBILE,
  constants.SS_KEY_GROUP_EMAIL1,
  constants.SS_KEY_GROUP_EMAIL3,
];

export const ARRAY_GROUP_OPS_SESSION = [constants.SS_KEY_GROUP_OPS_SESSION];

export const ARRAY_VCARD_ADMIN_SESSION = [constants.SS_KEY_VCARD_ADMIN_SESSION];
